import React, { useEffect, useMemo } from 'react'
import { MorphologyStore } from '../MorphologyStore';
import DesktopToolbar from './DesktopToolbar';
import SolutionInput from './SolutionInput';
import PauseCover from '../../shared/PauseCover';
import MorphologyTopBar from './MorphologyTopBar';
import { useShouldFloatToolbar } from '../../shared/utils';
import { getTodaysDateLabel, moveCursorToFirstOpenSlot, parseClueWithItalics } from '../morphologyUtils';
import AlmostThereDialog from './AlmostThereDialog';

const DesktopMorphology = () => {
  const { clues, author, guesses, solved, focusedClueIndex, completed, cryptic }
    = MorphologyStore.useState();

  // Parse clues once when clues change (only happens on initial load)
  const parsedClues = useMemo(() => {
    return clues.map(clue => parseClueWithItalics(clue.clue));
  }, [clues]);

  // handle scrolling things into view when using tab navigation
  useEffect(() => {
    const clueRows = document.querySelectorAll('.clueRow');
    const viewportHeight = window.innerHeight;

    const focused = clueRows[focusedClueIndex];

    const focusedRect = focused.getBoundingClientRect();

    const focusedIsBelowView = focusedRect.top > viewportHeight - 30;
    const focusedIsAboveView = focusedRect.bottom < 115;

    if (focusedIsBelowView) {
      focused.scrollIntoView({
        behavior: 'instant',
        block: "nearest",
      });
      return;
    }

    if (focusedIsAboveView) {
      window.scrollTo({
        top: focusedRect.top + window.scrollY - 105,
        behavior: 'instant'
      });
      return;
    }
  }, [focusedClueIndex]);

  const useFloatingToolbar = useShouldFloatToolbar(105);

  return (
    <>
      <MorphologyTopBar/>
      <AlmostThereDialog/>
      <div className="puzzleHeader">
        <div className="headerFirstLine">
          <div className="puzzleTitle">{cryptic ? 'Cryptic Morphology' : 'Morphology'}</div>
          <div className="puzzleDate">{getTodaysDateLabel()}</div>
        </div>
        <div className="puzzleAuthor">By {author}</div>
      </div>
      <div className="morphologyContainer">
        {!useFloatingToolbar && <DesktopToolbar/>}
        {clues.map((clue, i) => (
          <div
            className={`clueRow ${!solved && focusedClueIndex === i ? 'selected' : ''}`}
            key={i}
            onClick={(e: any) => {
              // this onClick is for when they click the row but not a specific cell in it
              MorphologyStore.update(s => {
                if (e.__isSelectingIndividualCell) return;
                s.focusedClueIndex = i;
                moveCursorToFirstOpenSlot(s);
              });
            }}
          >
            <div className="clueContainer">
              <div className="clueIndex">{i+1}</div>
              <div className="clueText">
                {parsedClues[i]}
              </div>
            </div>
            <div className="morph">{clue.morph || ''}</div>
            <div className="solutionInputContainer">
              <SolutionInput
                clueIndex={i}
                guess={guesses[i]}
              />
            </div>
          </div>
        ))}
      </div>
      <PauseCover store={MorphologyStore as any} useCompleted={true} completed={completed}/>
    </>
  );
};

export default DesktopMorphology;